import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appNoInput]',
  standalone: true,
})
export class NoInputDirective {
  @Input() appNoInput: boolean = true;
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInputEvent(event: any) {
    if (this.appNoInput) {
      event.preventDefault();
      this.el.nativeElement.value = '';
    }
  }

  @HostListener('paste', ['$event']) onPasteEvent(event: ClipboardEvent) {
    if (this.appNoInput) {
      event.preventDefault();
      const pastedText = (
        event.clipboardData || (window as any).clipboardData
      ).getData('text');
      this.el.nativeElement.value = '';
    }
  }

  @HostListener('drop', ['$event']) onDropEvent(event: DragEvent) {
    if (this.appNoInput) {
      event.preventDefault();
      const droppedText = event.dataTransfer?.getData('text');
      this.el.nativeElement.value = '';
    }
  }
}
